const months = [
  'janúar',
  'febrúar',
  'mars',
  'apríl',
  'maí',
  'júní',
  'júlí',
  'ágúst',
  'september',
  'október',
  'nóvember',
  'desember'
]

export const beautifyDate = (d: Date) =>
  `${d.getDate()}. ${months[d.getMonth()]} ${d.getFullYear()}`
